<template>
  <div v-if="currentUser" class="services-title-admin">
    <div class="page-header">
      <h1>Tytuły usług</h1>
      <button class="btn-primary" v-if="!addingActive" @click="addingActive = true">+ Dodaj tytuły</button>
      <button class="btn-outline" v-if="addingActive" @click="addingActive = false">Powrót do listy</button>
    </div>

    <div class="section-card" v-if="addingActive">
      <div class="section-card-header position-relative">
        <HintComponent page-key="admin_panel_service_titles" :absolute="true"/>
        <h2>Dodawanie tytułów</h2>
        <p class="section-subtitle">Wprowadź wiele tytułów, oddzielając je średnikiem <b>;</b>.</p>
      </div>

      <div class="form-group">
        <label for="categoryAdd">Specjalizacja</label>
        <select name="categoryAdd" id="categoryAdd" v-model="selectedAddCategory">
          <option value="">-- wybierz specjalizację --</option>
          <option :value="category.id" :key="category.id" v-for="category in categories">{{ category.name }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="titlesAdd">Tytuły po średniku</label>
        <textarea
            name="titlesAdd"
            id="titlesAdd"
            cols="30"
            rows="10"
            v-model="titlesToAdd"
            placeholder="strzyżenie psa;strzyżenie królika;leczenie zęba u psa"
        ></textarea>
      </div>

      <div class="form-actions">
        <button class="btn-green" @click="addTitles">Dodaj</button>
      </div>
    </div>

    <div class="section-card" v-else>
      <div class="section-card-header position-relative">
        <HintComponent page-key="admin_panel_service_titles" :absolute="true"/>
        <h2>Zarządzanie tytułami</h2>
      </div>

      <div class="form-group">
        <label for="categoryManage">Specjalizacja</label>
        <select name="categoryManage" id="categoryManage" v-model="selectedCategory" @change="getTitles(selectedCategory)">
          <option value="">-- wybierz specjalizację --</option>
          <option :value="category.id" :key="category.id" v-for="category in categories">{{ category.name }}</option>
        </select>
      </div>

      <div class="titles-block-cont" v-if="selectedCategory">
        <input type="checkbox" id="titlesBlock" v-model="titlesBlock" @change="titlesAddBlock">
        <label for="titlesBlock">Blokada automatycznego dodawania tytułów</label>
      </div>

      <div class="titles-list-wrap">
        <div class="search-row" v-if="selectedCategory">
          <input type="search" id="title" placeholder="Wyszukaj tytuł" @input="(e) => searchTitles(e.target.value)">
          <span class="titles-count">{{ titlesCount }} tytułów w bazie dla tej kategorii</span>
        </div>

        <div class="table-wrapper" v-if="selectedCategory">
          <table class="titles-table">
            <tbody>
            <tr v-for="title in titles" :key="title.id">
              <td>{{ title.content }}</td>
              <td class="actions-cell">
                <button class="btn-icon btn-danger" @click="deleteTitle(title.id)" title="Usuń">
                  <img src="@/assets/icons/trash.svg" alt="usuń">
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="empty-state" v-else>
          <p>Brak tytułów lub nie została wybrana specjalizacja.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'ServicesTitle',
  components: {HintComponent},
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      categories: null,
      titles: null,
      titlesBlock: false,
      selectedCategory: '',
      selectedAddCategory: '',
      titlesToAdd: '',
      addingActive: false,
      titlesCount: 0,
    };
  },
  props: ['isVisible'],
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getCategories();
  },
  methods: {
    getCategories() {
      axios.get('/Categories').then((res) => {
        this.categories = res.data;
      });
    },
    getTitles(id) {
      if (id) {
        axios.get(`/GetServiceTitles/${id}`).then(res => {
          this.titles = res.data.serviceTitles;
          this.titlesBlock = res.data.block == null ? false : res.data.block === 1;
          this.titlesCount = this.titles.length;
        });
      }
    },
    searchTitles(value) {
      if (value) {
        this.titles = this.titles.filter(item => item.content.toUpperCase().includes(value.toUpperCase()));
      } else {
        this.getTitles(this.selectedCategory);
      }
    },
    addTitles() {
      if (this.selectedAddCategory && this.titlesToAdd) {
        if (this.titlesToAdd.charAt(this.titlesToAdd.length - 1) === ';') {
          this.titlesToAdd = this.titlesToAdd.slice(0, -1);
        }
        if (this.titlesToAdd.charAt(0) === ';') {
          this.titlesToAdd = this.titlesToAdd.slice(1);
        }

        axios.post('/AddManyServiceTitles', {
          category_id: this.selectedAddCategory,
          titles: this.titlesToAdd,
        }, authHeader()).then(res => {
          if (String(res.status).charAt(0) === '2') {
            this.appStore.setIsSuccess('Pomyślnie dodano tytuły');
            this.titlesToAdd = '';
            this.selectedCategory = '';
            this.addingActive = false;
          }
        });
      } else {
        this.appStore.setIsAlert('uzupełnij kategorię oraz pole tytułów');
      }
    },
    deleteTitle(id) {
      axios.delete(`/DeleteServiceTitle/${id}`, authHeader()).then(res => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto tytuł');
          this.getTitles(this.selectedCategory);
        }
      });
    },
    titlesAddBlock() {
      axios.post('/AutoAddServiceTitleBlock', {
        block: this.titlesBlock,
        category_id: this.selectedCategory,
      }, authHeader()).then(res => {
        if (res.status === 200) {
          this.appStore.setIsSuccess('Pomyślnie zablokowano automatyczne dodawanie tytułów');
        }
      });
    },
  },
};
</script>

<style scoped>
.services-title-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group textarea,
.form-group select,
.search-row input {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus,
.search-row input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.form-group textarea {
  resize: vertical;
  min-height: 150px;
}

.titles-block-cont {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 12px 0;
  color: #374151;
  font-size: 1.4rem;
}

.titles-block-cont input {
  width: 16px;
  height: 16px;
  accent-color: #10b981;
}

.titles-list-wrap {
  margin-top: 6px;
}

.search-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.titles-count {
  color: #6b7280;
  font-size: 1.35rem;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.titles-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.titles-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 1.4rem;
  color: #1f2937;
}

.titles-table tr:last-child td {
  border-bottom: none;
}

.titles-table tr:hover td {
  background: #fcfcfd;
}

.actions-cell {
  width: 70px;
  text-align: center;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.empty-state {
  text-align: center;
  padding: 24px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-danger:hover {
  background-color: #fee2e2;
}

@media (max-width: 480px) {
  .services-title-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .form-actions {
    justify-content: stretch;
  }
}
</style>